// extracted by mini-css-extract-plugin
module.exports = {"media-box":"R6Jzy4dD"};